/**
 * Analytics Debugger Plugin
 * Initializes the analytics debugging tool for support team
 */

export default function ({ app, store }) {
  if (typeof window !== 'undefined') {
    // Dynamically import the debugger utility
    import('~/utils/analytics-debugger').then(({ default: AnalyticsDebugger }) => {
      console.log('[Analytics Debugger] Plugin loaded');

      // Wait for network data to be available
      const initializeDebugger = () => {
        const networkData = store.state['booking-networks']?.getBookingNetworksRequest?.data;

        // Pass both debug config and network data for full visibility
        const debugConfig = networkData?.analytics_debug || {};
        const initData = {
          ...debugConfig,
          networkData: networkData // Include full network data for debugging
        };

        window.analyticsDebugger.initialize(initData, networkData);
        console.log('[Analytics Debugger] Initialized with config:', debugConfig);
      };

      // Try immediate initialization
      if (store.state['booking-networks']?.getBookingNetworksRequest?.data) {
        initializeDebugger();
      } else {
        // Watch for network data changes
        store.watch(
          (state) => state['booking-networks']?.getBookingNetworksRequest?.data,
          (data) => {
            if (data) {
              initializeDebugger();
            }
          },
          { deep: true }
        );
      }
    }).catch(error => {
      console.error('[Analytics Debugger] Failed to load:', error);
    });
  }
}